import ATable from './src/main.vue';

ATable.install = function (Vue) {
  Vue.component(ATable.name, ATable);
}

export default ATable;
